import React from "react";
import { dialog, printComponent } from "../../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import FormFactory from "../../../components/FormFactory";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaContactPerson from "./schemas/schemaContactPerson.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaOtherDocs from "./schemas/schemaOtherDocs.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../../components/InputFactory";
import NavBar from "../../../components/navbar";
import InterviewCoordinatorFormPagePresenter from "./InterviewCoordinatorFormPagePresenter";
import DialogConfirmation from "../components/DialogConfirmation";
import ConsentPrint from "../components/ConsentPrint";
import DialogDate from "../components/DialogDate";
import DialogOnboard from "../components/DialogOnboard";
import DialogSuccess from "../components/DialogSuccess";
import { auditUseCase } from "../../../usecases/audit";

class InterviewCoordinatorFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      positions: [],
      selectedPosition: "",
      locations: [],
      onBoards: [],
      startDate: "",
      remarks: "",
      location: "",
      coordinators: [],
      coordinatorId: "",
    };
    this.presenter = new InterviewCoordinatorFormPagePresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase(),
      auditUseCase()
    );

    this.consentPDF = React.createRef();
  }

  getCollectionName() {
    const typeOfApplication = this.getApplicationType();
    switch (typeOfApplication) {
      case "online":
        return "online_applicants";
        break;
      case "walkIn":
        return "walkIn_applicants";
        break;
      default:
        return "reprocess_applicants";
        break;
    }
  }

  getApplicationType() {
    return this.props.params.type;
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  handleClickSchedule(startDateTime, endDateTime) {
    dialog.close();
    this.presenter.handleClickSchedule(startDateTime, endDateTime);
  }

  handleBackToPoll() {
    dialog.close();
    this.presenter.handleBackToPoll();
  }

  navigateToForm() {
    this.presenter.navigateToForm();
  }

  getLocations() {
    this.presenter.getLocations();
  }

  getCoordinators(location) {
    this.presenter.getCoordinators(location);
  }

  handleChange(event) {
    const selectedPosition = event.target.value;
    this.setState({ selectedPosition });
  }

  handleLocationChange(event) {
    const location = event.target.value;

    this.setState({ location }, () => {
      const coordinators = this.getCoordinators(location);

      this.setState({ coordinators: coordinators || [] });
    });
  }

  handleCoordinatorChange(event) {
    const coordinatorId = event.target.value;
    this.setState({ coordinatorId });
  }

  handleClickApprove() {
    this.presenter.handleClickApprove();
  }

  onclickApprove() {
    const { object } = this.state;

    dialog.fire({
      html: (
        <>
          <DialogConfirmation
            title={"Approve Application"}
            type={"approve"}
            object={object}
            handleConfirm={this.handleClickApprove.bind(this)}
          />
        </>
      ),
      footer: false,
    });
  }
  handleClickReject() {
    this.presenter.handleClickReject();
  }

  onChangeRemarks(event) {
    const value = event.target.value;
    this.setState({ remarks: value }, () => {});
  }

  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  onclickReject() {
    const { object } = this.state;

    dialog.fire({
      html: (
        <>
          <DialogConfirmation
            title={"Reject Application"}
            type={"reject"}
            object={object}
            handleConfirm={this.handleClickReject.bind(this)}
            onchange={this.onChangeRemarks.bind(this)}
          />
        </>
      ),
      footer: false,
    });
  }

  onClickApprove() {
    const { object } = this.state;
    dialog.fire({
      html: (
        <DialogConfirmation
          title={"Approve Application"}
          type={"approve"}
          object={object}
          handleConfirm={this.handleClickApprove.bind(this)}
        />
      ),
    });
  }

  handleOnclickPrint() {
    this.presenter.handleOnclickPrint();
  }

  exportPDF() {
    printComponent(this.consentPDF.current);
  }

  onClickPrint() {
    this.presenter.onClickPrint();
  }

  goBack() {
    const history = window.history;
    history.back();
  }

  onchangeDateStart(event) {
    const value = event.target.value;
    this.setState({ startDate: value });
  }

  onConfirmDateStart() {
    const { startDate } = this.state;
    this.presenter.handleAddStartDate(startDate);
  }

  onclickDateStart() {
    dialog.fire({
      html: (
        <DialogDate
          onchange={this.onchangeDateStart.bind(this)}
          handleConfirm={this.onConfirmDateStart.bind(this)}
        />
      ),
      footer: false,
    });
  }

  getRecruiterId() {
    return this.props.params.recruiterId;
  }

  handleClickOnboard(startDateTime, endDateTime, date) {
    dialog.close();
    this.presenter.handleClickOnboard(startDateTime, endDateTime, date);
  }

  onBoardSubmit() {
    const user = this.getCurrentUser();
    const { onBoards } = this.state;

    dialog.fire({
      html: (
        <DialogOnboard
          onBoards={onBoards}
          user={user}
          handleAssign={this.handleClickOnboard.bind(this)}
        />
      ),
      footer: false,
    });
  }

  typeOfApplication() {
    const collection = this.getCollectionName();
    switch (collection) {
      case "online_applicants":
        return "online";
        break;
      case "walkIn_applicants":
        return "walkIn";
        break;
      default:
        return "reprocess";
    }
  }

  navigateToInterviewForm() {
    const { object } = this.state;
    const typeOfApplication = this.typeOfApplication();
    this.navigateTo(`/interview/form/${typeOfApplication}/${object?.id}`);
  }

  listButton() {
    const { object } = this.state;
    const interviewDatas = sessionStorage.getItem("interviewDatasOnline");

    return (
      <>
        <button
          className="btn text-white fw-bold"
          style={{ backgroundColor: "#3174ad" }}
          onClick={this.navigateToInterviewForm.bind(this)}
        >
          <i class="bi bi-file-earmark-text me-2 fw-bold"></i>
          Interview Form
        </button>{" "}
        <button
          className="btn text-white fw-bold"
          style={{ backgroundColor: "#e09552" }}
          disabled={object?.status !== "For Endorsement"}
          onClick={this.onBoardSubmit.bind(this)}
        >
          <i class="bi bi-calendar-event me-2"></i>
          Onboard
        </button>{" "}
        <button
          className="btn text-white fw-bold"
          style={{
            backgroundColor: !object?.startDate ? "#3174ad7d" : "#3174ad",
          }}
          onClick={this.onClickPrint.bind(this)}
          disabled={!object?.startDate}
        >
          <i class="bi bi-printer me-2"></i>
          Print Endorsement Form
        </button>{" "}
        <button
          className="btn text-white fw-bold"
          style={{
            backgroundColor:
              !object?.hireDate || object?.startDate ? "#ababab" : "#5d5d5d",
          }}
          onClick={this.onclickDateStart.bind(this)}
          disabled={!object?.hireDate || object?.startDate}
        >
          <i class="bi bi-calendar-event me-2"></i>
          Date Start
        </button>{" "}
        <button
          className="btn text-white fw-bold"
          style={{ backgroundColor: "#e09552" }}
          onClick={this.onclickApprove.bind(this)}
          disabled={object?.hireDate}
        >
          <i class="bi bi-check me-2"></i>
          Approve
        </button>{" "}
        <button
          className="btn text-dark fw-bold"
          style={{ backgroundColor: "#d3d3d3" }}
          onClick={this.onclickReject.bind(this)}
          disabled={object?.hireDate}
        >
          <i class="bi bi-x me-2"></i>
          Reject
        </button>
      </>
    );
  }

  viewFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  render() {
    const { object, whereLGSSee, onBoards } = this.state;
    const user = this.getCurrentUser();
    const isAddressSame =
      object.permanent_barangay === object.present_barangay &&
      object.permanent_city === object.present_city &&
      object.permanent_houseNumber === object.present_houseNumber &&
      object.permanent_province === object.present_province &&
      object.permanent_street === object.present_street &&
      object.permanent_subdivision === object.present_subdivision &&
      object.permanent_zipCode === object.present_zipCode &&
      object.telephone === object.present_telephone;

    console.warn("coordinatorinterview", object);
    return (
      <>
        <div className="d-none">
          <div ref={this.consentPDF}>
            <ConsentPrint object={object} />
          </div>
        </div>
        <NavBar user={user} />
        <div>
          <div className="p-4 overflow-auto">
            <div className="d-flex gap-4 justify-content-between">
              <div className="d-flex">
                <h1 className="fw-bold fs-4">
                  <div className="d-flex gap-3 mb-3 align-items-center">
                    <div
                      className="rounded-5 p-1 cursor-pointer"
                      style={{ backgroundColor: `#E6E6E6` }}
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        class="bi bi-arrow-left-short"
                        style={{ width: `1rem`, height: `1rem` }}
                      ></i>
                    </div>
                    <span style={{ color: `#D18237` }}>Application Form</span>
                  </div>
                </h1>
              </div>

              <div>{this.listButton()}</div>
            </div>
            <div className="d-flex flex-column">
              <div className="bg-white p-4 rounded-3 d-flex flex-column gap-0">
                <form>
                  <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                  <p className="p-0 m-0">
                    1. Answer ALL questions completely and accurately.
                  </p>
                  <p className="p-0 m-0">
                    2. Provide all information to the best of your knowledge.
                  </p>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column justify-content-md-start mt-3 gap-2">
                      <div className="d-flex flex-column gap-2">
                        <b>Where did you see LGS?</b>
                        <InputFactory
                          type="String"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="seeLGS"
                          defaultValue={object.seeLGS}
                          disabled
                        />
                        {whereLGSSee === "Recruiter" ? (
                          <div>
                            <select className="form-control bg-light-subtle p-2">
                              <option selected disabled>
                                Select Recruiter
                              </option>
                            </select>
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            <p className="text-muted m-0 p-0">
                              Position/s Applied for:
                            </p>

                            <InputFactory
                              type="String"
                              required
                              className="form-control bg-light-subtle p-2"
                              placeholder="Select"
                              field="positionApplied"
                              defaultValue={object.positionApplied}
                              disabled
                            />
                          </div>
                        )}
                      </div>
                      <div className="mt-2">
                        <b>Do you have any relative in:</b>
                        <div className="mt-2">
                          <label className="form-label fs-sm">LGS</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeLGS"
                            defaultValue={object.relativeLGS}
                            disabled
                          />
                        </div>
                        <div>
                          <label className="form-label fs-sm">Client</label>
                          <InputFactory
                            type="String"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeClient"
                            defaultValue={object.relativeClient}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-3 mt-3 col-lg-8">
                      <div className="d-flex flex-column align-items-center">
                        <label className="fw-bold">
                          Image 1
                          <span className="text-danger fw-lighter ms-1">*</span>
                        </label>
                        {object?.image1 ? (
                          <div
                            className="border-1 border rounded-3 position-relative col-sm-6"
                            style={{ width: "300px", height: "300px" }}
                          >
                            <img
                              className="w-100 h-100 rounded-1 object-fit-contain"
                              src={`${object?.image1}`}
                              alt="Uploaded file"
                              style={{ objectFit: "cover" }}
                            />
                            <button
                              className="btn btn-sm bg-white position-absolute"
                              onClick={() => this.viewFile(object?.image1)}
                              style={{ top: `2%`, right: `2%` }}
                            >
                              <i class="bi bi-eye text-success"></i>
                            </button>
                          </div>
                        ) : (
                          <div
                            className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle"
                            style={{ width: "300px", height: "300px" }}
                          >
                            <a href="#uploadImage">
                              <img
                                className="w-100 h-100"
                                src="/defaultImage.png"
                                alt="Default Image"
                                style={{ objectFit: "cover" }}
                              />
                            </a>
                          </div>
                        )}
                      </div>

                      <div className="d-flex flex-column align-items-center">
                        <label className="fw-bold">
                          Image 2
                          <span className="text-danger fw-lighter ms-1">*</span>
                        </label>
                        {object?.image2 ? (
                          <div
                            className="border-1 border rounded-3 position-relative col-sm-6"
                            style={{ width: "300px", height: "300px" }}
                          >
                            <img
                              className="w-100 h-100 rounded-1 object-fit-contain"
                              src={`${object?.image2}`}
                              alt="Uploaded file"
                              style={{ objectFit: "cover" }}
                            />
                            <button
                              className="btn btn-sm bg-white position-absolute"
                              onClick={() => this.viewFile(object?.image2)}
                              style={{ top: `2%`, right: `2%` }}
                            >
                              <i className="bi bi-eye text-success fw-bold"></i>
                            </button>
                          </div>
                        ) : (
                          <div
                            className="border-1 border rounded-3 position-relative col-sm-6 bg-light-subtle"
                            style={{ width: "300px", height: "300px" }}
                          >
                            <a href="#uploadImage">
                              <img
                                className="w-100 h-100"
                                src="/defaultImage.png"
                                alt="Default Image"
                                style={{ objectFit: "cover" }}
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-5">
                    <b>Personal Information</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaPersonalForm1}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPermanentAddress}
                      object={object}
                      disabled
                    />
                  </div>
                  {isAddressSame ? (
                    <div className="row justify-content-md-start mt-3">
                      <div className="col-md-5 d-flex gap-2">
                        <input
                          type="checkbox"
                          className="cursor-pointer"
                          checked={isAddressSame}
                          disabled
                        />
                        <p className="m-0 p-0">
                          Permanent Address same as a Present Address
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {isAddressSame ? (
                    ""
                  ) : (
                    <div className="row justify-content-md-start mt-3">
                      <div className="mt-4">
                        <b>Present Address</b>
                      </div>
                      <FormFactory
                        schema={schemaPresentAddress}
                        object={object}
                        disabled
                      />
                    </div>
                  )}

                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaIdForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Emergency Contact Person</b>
                    <hr></hr>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaContactPerson}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Educational Information</b>
                    <hr />
                  </div>
                  <div className="mt-4">
                    <b>High School</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaHSForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>College</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaColForm}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex">
                      <InputFactory
                        type="Boolean"
                        field="isFreshGrad"
                        label="Fresh Graduate"
                        object={object}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <b>Employment Background</b>
                    <hr />
                  </div>
                  <div>
                    <div className="row justify-content-md-start mt-3">
                      <div className="row justify-content-md-start mt-3">
                        {object.employmentBackground?.map(
                          (employment, index) => (
                            <FormFactory
                              schema={schemaEmployment}
                              object={employment}
                              disabled
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <b>Character References</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <div className="row justify-content-md-start mt-3">
                      {object.characterReferences?.map((reference, index) => (
                        <FormFactory
                          schema={schemaCharacterRef}
                          disabled
                          object={reference}
                        />
                      ))}
                    </div>
                  </div>

                  <div className="mt-4">
                    <b>School Record</b>
                    <hr />
                  </div>

                  <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                    {object?.diploma ? (
                      <div className="col-lg-3">
                        <label>Diploma</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Diploma"
                          field="diploma"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.tor ? (
                      <div className="col-lg-3">
                        <label>TOR</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="TOR"
                          field="tor"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.reportCard ? (
                      <div className="col-lg-3">
                        <label>Report Card</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Report Card"
                          field="reportCard"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    {object?.graduationCertificate ? (
                      <div className="col-lg-3">
                        <label>Graduation Certificate</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Graduation Certificate"
                          field="graduationCertificate"
                          disabled
                          object={object}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="mt-4">
                    <b>Upload Documents</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaDocForm}
                      disabled
                      object={object}
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory schema={schemaOtherDocs} object={object} />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(InterviewCoordinatorFormPage);
